<script setup>
import {computed} from "vue";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";

const props = defineProps({
  organisationId: {
    required: true,
    type: [String, Number],
  },
  currentPeriod: {
    required: true,
    type: String,
  },
});

const alternatePeriod = computed(() => {
  if (props.currentPeriod === 'MONTH') {
    return 'YEAR';
  }

  return 'MONTH';
});

const {mutate, isPending} = useMutation({
  mutationFn: function () {
    return axios.post(`/ajax/v2/admin/organisation/${props.organisationId}/swap-billing-period`);
  },
  onSuccess: () => {
    successToast("Billing period updated successfully, refreshing page...");

    setTimeout(() => {
      window.location.reload();
    }, 1500);
  },
  onError: (error) => {
    let message = 'Something went wrong updating the billing period';
    if (error.response && error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }
    errorToast(message, 'Failed to update billing period');
    console.error(error);
  },
})

const handleClick = () => {
  const confirm = window.confirm(
    `Are you sure you want to swap this organisation's billing period from ${props.currentPeriod} to ${alternatePeriod.value}?
    \n\n
    Note: This will not update their Stripe account.`
  )
  if (!confirm) {
    return;
  }

  mutate();
}
</script>

<template>
  <button
    type="button"
    title="Swap billing period"
    class="swap-billing-button"
    :disabled="isPending"
    @click="handleClick"
  >
    <i
      class="fa fa-exchange"
      :class="{
        'fa-spin': isPending,
      }"
    />
  </button>
</template>

<style lang="scss" scoped>
.swap-billing-button {
  background: transparent;
  border: none;
  padding: .25rem .5rem;
  font-size: .7rem;

  &:disabled {
    opacity: .7;
  }
}
</style>